import { useEffect, useState } from "react";
import { useSearchParams } from "@/lib/router";
import useAppNavigate from "@/hooks/useAppNavigate";
import { getAuth, signInWithCustomToken } from "firebase/auth";
import { useSigninCheck } from "reactfire";

const useAuthTokenCheck = () => {
  const auth = getAuth();
  const { data } = useSigninCheck();
  const [searchParams] = useSearchParams();
  const navigateTo = useAppNavigate();

  const [checkingToken, setCheckingToken] = useState(true);

  useEffect(() => {
    const authToken = searchParams.get("auth-token");
    if (authToken && !data?.signedIn) {
      setCheckingToken(true);
      signInWithCustomToken(auth, authToken).finally(() => {
        setCheckingToken(false);
        navigateTo(window.location.pathname, {
          noPreserveKey: ["auth-token"],
        });
      });
    } else {
      setCheckingToken(false);
    }
  }, [auth, data?.signedIn, searchParams]);

  return { checkingToken };
};

export default useAuthTokenCheck;
